import { LoadingState } from '@nocowanie/core/enums';

import { AccommodationTilesResponse } from '@app/helpers/accommodation-tiles.helpers';

import { GeoBaseModel } from './geo.model';

export interface ListingBreadcrumbItem {
    position: number;
    name: string;
    item: string;
}

export interface ListingMeta {
    loading: LoadingState;
    errors?: unknown;
    data: {
        pageTitle: string;
        header: string;
        pageCount: number;
        itemCount: number;
        cmsId?: string;
        checkIn?: string | null;
        checkOut?: string | null;
        flexDates?: number | null;
        locationDetails?: GeoBaseModel;
    };
}

export interface ListingItems {
    loading: LoadingState;
    errors?: unknown;
    data: AccommodationTilesResponse | null;
}

export interface ListingState {
    meta: ListingMeta;
    items: ListingItems;
}

export enum ListingUrlPart {
    Centrum = 'centrum',
    Opinie = 'opinie',
    Sortuj = 'sortuj',
    OfertySpecjalne = 'oferty_specjalne',
}

export enum ListingGeoPrefix {
    Noclegi = 'noclegi',
    Regiony = 'regiony',
}

export enum ListingAmenitySlug {
    // Amenities supported in API
    Catering = 'wyzywienie',
    ChildrensArea = 'plac_zabaw',
    Jacuzzi = 'jacuzzi',
    Parking = 'parking',
    SwimmingPool = 'basen',
    Tv = 'telewizor',
    Wifi = 'internet',

    // Unsupported in NocApi
    AirConditioning = 'z_klimatyzacja',
    Fireplace = 'kominek',
    EVCharger = 'stacje_ladowania_ev',

    // Unsupported in NocApi - but might be supported in the future
    WithBreakfast = 'ze_sniadaniem',
}

export enum ListingPropertyTypeSlug {
    RuralTourism = 'agroturystyka',
    Apartment = 'apartamenty',
    Chalet = 'domki',
    HolidayHome = 'domy_wakacyjne',
    Hostel = 'hostele',
    Hotel = 'hotele',
    StudentHostel = 'internaty_schroniska',
    Guesthouse = 'kwatery_i_pokoje',
    WorkerAccommodation = 'noclegi_pracownicze',
    Motel = 'motele',
    Resort = 'os__wypoczynkowe',
    Pension = 'pensjonaty',
    Villa = 'willa',
    Inn = 'zajazd',
}

export type ListingUrlPrefix = ListingAmenitySlug | ListingGeoPrefix | ListingPropertyTypeSlug;
